import { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import StudentSvg from "../../assets/student.svg";
import Book from "../../assets/book.svg";
import "./Dashboard.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
ChartJS.register(ArcElement, Tooltip, Legend);

const Dashboard = () => {
  const [totalStudents, setTotalStudents] = useState(0);
  const [totalStaffs, setTotalStaffs] = useState(0);
  const [studentClassData, setStudentClassData] = useState([]);
  const token = JSON.parse(localStorage.getItem("token"));
  // Fetch total number of students, staff, and students by class
  useEffect(() => {
    const fetchTotalStudents = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/students/count`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch total students");
        }
        const data = await response.json();
        setTotalStudents(data.count);
      } catch (error) {
        console.error("Error fetching total students:", error);
      }
    };

    const fetchTotalStaffs = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/staffs/count`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch total staff");
        }
        const data = await response.json();
        setTotalStaffs(data.count);
      } catch (error) {
        console.error("Error fetching total staff:", error);
      }
    };

    const fetchStudentClassData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/students/class-count`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch student class data");
        }
        const data = await response.json();
        setStudentClassData(data.classes || []); // Default to an empty array if data is missing
      } catch (error) {
        console.error("Error fetching student class data:", error);
      }
    };

    fetchTotalStudents();
    fetchTotalStaffs();
    fetchStudentClassData();
  }, []);

  // Process class data for the doughnut chart
  const studentClassChartData = {
    labels: studentClassData.map((item) => `Class ${item._id}`),
    datasets: [
      {
        data: studentClassData.map((item) => item.count),
        backgroundColor: [
          "#36A2EB",
          "#FF6384",
          "#FF9F40",
          "#4BC0C0",
          "#FFCD56",
        ],
        hoverBackgroundColor: [
          "#6CC0ED",
          "#FF7F9E",
          "#FFBF77",
          "#76D6D6",
          "#FFEB77",
        ],
      },
    ],
  };

  const staffChartData = {
    labels: ["Total Staffs"],
    datasets: [
      {
        data: [totalStaffs],
        backgroundColor: ["#FF6384"],
        hoverBackgroundColor: ["#FF7F9E"],
      },
    ],
  };

  return (
    <>
      <ToastContainer />
      <div className="container text-white bg-gradient bg-success rounded pb-1 mb-5">
        <div className="row m-5 text-center p-5">
          {/* Render student chart only if data exists */}
          <div className="col-md-6 d-flex justify-content-center align-items-center student-chart">
            <div
              className="doughnut-container"
              style={{ width: "250px", height: "250px" }}
            >
              <h5>Total Students - {totalStudents}</h5>
              {totalStudents > 0 && studentClassData.length > 0 ? (
                <Doughnut data={studentClassChartData} />
              ) : (
                ""
              )}
            </div>
          </div>

          {/* Render staff chart */}
          <div className="col-md-6 d-flex justify-content-center align-items-center staff-chart">
            <div
              className="doughnut-container"
              style={{ width: "250px", height: "250px" }}
            >
              <h5>Total Staffs - {totalStaffs}</h5>
              {totalStaffs > 0 ? <Doughnut data={staffChartData} /> : ""}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
